import { render, staticRenderFns } from "./ElderlyCalls.vue?vue&type=template&id=53c15c2b&"
import script from "./ElderlyCalls.vue?vue&type=script&lang=js&"
export * from "./ElderlyCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports